import React from 'react';
import { Link } from 'react-router-dom';

export default function ProcurementProductName({ product }) {
  return (
    <div>
      <Link
        to={`/admin/products?productId=${product.productId}`}
        className='text-dark font-weight-bold'
      >
        {product.productName || `Товар #${product.productId}`}
      </Link>
      {product.parentProductName && (
        <div className='small text-muted'>{product.parentProductName}</div>
      )}
      <div className='small text-muted'>
        Артикул: {product.productCode || '—'} · ID {product.productId}
      </div>
      {product.stockNeedsReview && (
        <div className='text-danger small'>Від’ємний залишок — потрібна звірка</div>
      )}

    </div>
  );
}
